import PropTypes from 'prop-types';
import {memo} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {RadioButtonCommon, Rating, SimpleCollapse, Text} from '../../ui';
import FilterRow from '../components/FilterRow';

const RatingFilters = ({query, setQueryFilters}) => {
  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.Ratings'} />
        </Text>
      }
    >
      {/*@ts-ignore*/}
      {[...Array(6).keys()].map((ratingValue) => (
        <FilterRow key={ratingValue}>
          <RadioButtonCommon
            id={ratingValue.toString()}
            type="radio"
            name="rating_filter"
            label={<Rating rating={ratingValue} />}
            data-filter-name={SEARCH_FILTERS.FILTERS_AVERAGE_SCORE}
            data-value={ratingValue.toString()}
            checked={
              query[SEARCH_FILTERS.FILTERS_AVERAGE_SCORE] ===
              ratingValue.toString()
            }
            onChange={() => {
              setQueryFilters({
                [SEARCH_FILTERS.FILTERS_AVERAGE_SCORE]: ratingValue.toString(),
              });
            }}
          />
        </FilterRow>
      ))}
    </SimpleCollapse>
  );
};

RatingFilters.propTypes = {
  query: PropTypes.object.isRequired,
  setQueryFilters: PropTypes.func.isRequired,
};

export default memo(RatingFilters);
